import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasemodelService } from 'src/app/basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class HygineReportService {
 private token3="eyJhbGciOiJIUzI1NiJ9.eyJ0b2tlblJlZnJlc2hLZXkiOiJ1ZDY3UGxlNGg0d1VSdzMySGdQQUh2dVF0TUclMkJIRFlKUVlrTjlVS3klMkZkayUzRCIsImNhbXB1c0lkIjo0NjIsInBheXJvbGxJZCI6IkhZRDEwMzEzNSIsInVzZXJOYW1lIjoiQ0ggU0FUWUFOQVJBWUFOQSIsImV4cCI6MTc1NjAxNTA3NiwidXNlcklkIjoiSFlEMTAzMTM1IiwiaWF0IjoxNzU1OTI4Njc2LCJ1bmlxdWVJZCI6Mjg0ODYsImp0aSI6IjFjYjlmYmUwLWYwMTYtNDRkNy05NDc2LTA0NGY3M2MzZWE0OCJ9.Aq48RtPbtBHSP5X5JjvoERjPOPdCbplqz8wS90OBtpM"
 constructor(public http: HttpClient,) { }


 gethyginelist(){
   const headers = new HttpHeaders({
     'Authorization':'Bearer '+ this.token3,
     'Content-Type':'application/json'
   })
   return this.http.get("https://testmasters.scaits.net/apiV2/hygieneReport",{headers})
 }
 imagelist(hygineId:any){
   const headers = new HttpHeaders({
     'Authorization':'Bearer '+ this.token3,
     'Content-Type':'application/json'
   })
   return this.http.get("https://testmasters.scaits.net/apiV2/imageList?hygieneId="+hygineId,{headers})
 }

}
